import EventEmitter from "event-emitter";
import Annotations from "../annotations";
import { EVENTS } from "../utils/constants";

import ExEpubCFI from "./epubcfi";

class ExAnnotations extends Annotations{
    constructor (rendition) {
        super(rendition);

		//加入bookmark
		this.bookmarks = [];
		this._bookmarksBySectionIndex = {};
		
    }

	check(type, cfiRange, data, cb, className, styles){
		let hash = encodeURI(cfiRange + type);
		let old_annotation_data;
		let old_annotation = this._annotations[hash];
		switch(type){

		case "bookmark": if(old_annotation){
			old_annotation_data = JSON.parse(JSON.stringify(old_annotation.data));
			return (JSON.stringify(data) === JSON.stringify(old_annotation_data)) ? old_annotation : false;
		}break;

		case "highlight": if(old_annotation ){
			old_annotation_data = JSON.parse(JSON.stringify(old_annotation.data));
			delete old_annotation_data['cfi'];
			return ((JSON.stringify(data) === JSON.stringify(old_annotation_data)) && (old_annotation.className === className)) ? old_annotation : false;
		}break;

		}
		return false;
	}

    /**
	 * Add an annotation to store
	 * @param {string} type Type of annotation to add: "highlight", "underline", "mark"
	 * @param {EpubCFI} cfiRange EpubCFI range to attach annotation to
	 * @param {object} data Data to assign to annotation
	 * @param {function} [cb] Callback after annotation is added
	 * @param {string} className CSS class to assign to annotation
	 * @param {object} styles CSS styles to assign to annotation
	 * @returns {ExAnnotation} annotation
	 */
	add (type, cfiRange, data, cb, className, styles) {
		let hash = encodeURI(cfiRange + type);
		let cfi = new ExEpubCFI(cfiRange);
		let sectionIndex = cfi.spinePos;
		let annotation = new ExAnnotation({
			type,
			cfiRange,
			data,
			sectionIndex,
			cb,
			className,
			styles
		});

		this._annotations[hash] = annotation;

		if(type === "bookmark"){
			if (sectionIndex in this._bookmarksBySectionIndex) {
				this._bookmarksBySectionIndex[sectionIndex].push(hash);
			} else {
				this._bookmarksBySectionIndex[sectionIndex] = [hash];
			}
		}else{
			if (sectionIndex in this._annotationsBySectionIndex) {
				this._annotationsBySectionIndex[sectionIndex].push(hash);
			} else {
				this._annotationsBySectionIndex[sectionIndex] = [hash];
			}
		}

		let views = this.rendition.views();

		views.forEach( (view) => {
			if (annotation.sectionIndex === view.index) {
				annotation.attach(view);
			}
		});

		return annotation;
	}

	getAnnotationByCfiRangeAndType(type, cfiRange){
		let hash = encodeURI(cfiRange + type);
		return (this._annotations[hash]) ? this._annotations[hash] : null;
	}

	/**
	 * Remove an annotation from store
	 * @param {EpubCFI} cfiRange EpubCFI range the annotation is attached to
	 * @param {string} type Type of annotation to add: "highlight", "underline", "mark"
	 */
	 remove (cfiRange, type) {
		let hash = encodeURI(cfiRange + type);

		if (hash in this._annotations) {
			let annotation = this._annotations[hash];

			if (type && annotation.type !== type) {
				return;
			}

			if(type === "bookmark"){
				this._removeFromBookmarksBySectionIndex(annotation.sectionIndex, hash);
			}else{
				let views = this.rendition.views();
				views.forEach( (view) => {
					this._removeFromAnnotationBySectionIndex(annotation.sectionIndex, hash);
					if (annotation.sectionIndex === view.index) {
						annotation.detach(view);
					}
				});
			}

			delete this._annotations[hash];
		}
	}

	 _removeFromBookmarksBySectionIndex (sectionIndex, hash) {
		this._bookmarksBySectionIndex[sectionIndex] = this._bookmarkAt(sectionIndex).filter(h => h !== hash);
	}

	/**
	 * Hook for injecting annotation into a view
	 * @param {View} view
	 * @private
	 */
	//即時顯示時, DOM依瀏覽器效能的關係, 會有延遲就定位的狀況, 所以延遲一下顯示的時間, 以緩解 highlight 不準確的狀況 
	inject (view) {
		if(!this.rendition.settings.isHidden){
			view.contents.finalSizeCheck().then(() => {
				let sectionIndex = view.index;
				//console.log(sectionIndex + " draw highlight");
				if (sectionIndex in this._annotationsBySectionIndex) {
					let annotations = this._annotationsBySectionIndex[sectionIndex];
					annotations.forEach((hash) => {
						let annotation = this._annotations[hash];
						annotation.attach(view);
					});
				}
			});
		}
	}

	//加入bookmark
	bookmark (cfiRange, data) {
		return this.add("bookmark", cfiRange, data);
	}

	//檢查highlight
	checkBookmark (cfiRange, data) {
		return this.check("bookmark", cfiRange, data);
	}

	//刪除bookmark
	removeBookmark (cfiRange) {
		this.remove(cfiRange, "bookmark");
	}

	_bookmarkAt (index) {
		return this._bookmarksBySectionIndex[index];
	}

	//刪除highlight
	removeHighlight(cfiRange){
		this.remove(cfiRange, "highlight");
	}

	//檢查highlight
	checkHighlight (cfiRange, data, cb, className, styles) {
		return this.check("highlight", cfiRange, data, cb, className, styles);
	}

	getBookmarkCFIData(location){
		let bookmarkCFIData = null;
		if(location){
			let summary = '';
			if(location.start.index === location.end.index){
				let section = this.rendition.book.spine.get(location.start.cfi);
				let exCFI = new ExEpubCFI();
				let rangeCFI = exCFI.getRangeFromStartEndCFI(location.start.cfi, location.end.cfi);
				let cfi = new ExEpubCFI(rangeCFI);
				let range = cfi.toRange(section.document);
				summary = (range) ? range.toString().substring(0,50) : '';
			}else{
				let startSection = this.rendition.book.spine.get(location.start.cfi);
				let startExCFI = new ExEpubCFI();
				let startRangeCFI = startExCFI.getRangeFromStartEndCFI(location.start.cfi, location.start.cfiRange);
				let startCfi = new ExEpubCFI(startRangeCFI);
				let startRange = startCfi.toRange(startSection.document);
				let startSummary = (startRange) ? startRange.toString() : '';

				let endSection = this.rendition.book.spine.get(location.end.cfiRange);
				let endExCFI = new ExEpubCFI();
				let endRangeCFI = endExCFI.getRangeFromStartEndCFI(location.end.cfiRange, location.end.cfi);
				let endCfi = new ExEpubCFI(endRangeCFI);
				let endRange = endCfi.toRange(endSection.document);
				let endSummary = (endRange) ? endRange.toString() : '';
				summary = (startSummary+endSummary).substring(0,50);

				//console.log(summary);
			}
			bookmarkCFIData = {
				cfi: location.start.cfi,
				highlight_text: summary,
				chapter: location.start.label,
				page: `${location.start.index}/${location.start.displayed.page}/${location.start.displayed.total}`,
				spine: location.start.index,
				href: location.start.href
			}
		}
		return bookmarkCFIData;
	}
}

/**
 * Annotation object
 * @class
 * @param {object} options
 * @param {string} options.type Type of annotation to add: "highlight", "underline", "mark"
 * @param {EpubCFI} options.cfiRange EpubCFI range to attach annotation to
 * @param {object} options.data Data to assign to annotation
 * @param {int} options.sectionIndex Index in the Spine of the Section annotation belongs to
 * @param {function} [options.cb] Callback after annotation is clicked
 * @param {string} className CSS class to assign to annotation
 * @param {object} styles CSS styles to assign to annotation
 * @returns {Annotation} annotation
 */
 class ExAnnotation {

	constructor ({
		type,
		cfiRange,
		data,
		sectionIndex,
		cb,
		className,
		styles
	}) {
		this.type = type;
		this.cfiRange = cfiRange;
		this.data = data;
		this.sectionIndex = sectionIndex;
		this.mark = undefined;
		this.cb = cb;
		this.className = className;
		this.styles = styles;
	}

	/**
	 * Update stored data
	 * @param {object} data
	 */
	update (data) {
		this.data = data;
	}

	/**
	 * Add to a view
	 * @param {View} view
	 */
	attach (view) {
		let {cfiRange, data, type, mark, cb, className, styles} = this;
		let result;

		if (type === "highlight") {
			result = view.highlight(cfiRange, data, cb, className, styles);
		} else if (type === "underline") {
			result = view.underline(cfiRange, data, cb, className, styles);
		} else if (type === "mark") {
			result = view.mark(cfiRange, data, cb);
		}

		this.mark = result;
		this.emit(EVENTS.ANNOTATION.ATTACH, result);
		return result;
	}

	/**
	 * Remove from a view
	 * @param {View} view
	 */
	detach (view) {
		let {cfiRange, type} = this;
		let result;

		if (view) {
			if (type === "highlight") {
				result = view.unhighlight(cfiRange);
			} else if (type === "underline") {
				result = view.ununderline(cfiRange);
			} else if (type === "mark") {
				result = view.unmark(cfiRange);
			}
		}

		this.mark = undefined;
		this.emit(EVENTS.ANNOTATION.DETACH, result);
		return result;
	}

	/**
	 * [Not Implemented] Get text of an annotation
	 * @TODO: needs implementation in contents
	 */
	text () {

	}
}

EventEmitter(ExAnnotation.prototype);

export default ExAnnotations;